import axios from 'axios';

import {
	type StoreAutoCompleteModel,
	type StoreListingModel,
	type StoreRequest,
	storeAutoCompleteModelSchema,
	storeListingModelSchema,
	storeListingResponseSchema,
	storeRequestSchema,
} from '../models';

/** @see AppleRetail.Web.Features.Stores.StoreListingController */
export async function getActiveStores(signal?: AbortSignal): Promise<StoreListingModel[]> {
	const response = await axios.get<unknown>('api/stores/active', { signal: signal });
	return storeListingModelSchema.array().parse(response.data);
}

/** @see AppleRetail.Web.Features.Stores.StoreListingController */
export async function getAccessibleStores(signal?: AbortSignal): Promise<StoreAutoCompleteModel[]> {
	const response = await axios.get<unknown>('api/stores/accessible', { signal: signal });
	return storeAutoCompleteModelSchema.array().parse(response.data);
}

/** @see AppleRetail.Web.Features.Stores.StoreListingController.GetAccessibleStoreList */
export async function getAccessibleStoreList(signal?: AbortSignal): Promise<StoreListingModel[]> {
	const response = await axios.get<unknown>('api/stores/accessible/list', { signal: signal });
	return storeListingModelSchema.array().parse(response.data);
}

/** @see AppleRetail.Web.Features.Stores.StoreListingController.Post */
export async function getStores(request: StoreRequest, signal?: AbortSignal) {
	request = storeRequestSchema.parse(request);
	const { data } = await axios.post<unknown>('/api/stores', request, { signal });
	return storeListingResponseSchema.parse(data);
}

/** @see AppleRetail.Web.Features.Stores.StoreListingController */
export async function autocomplete(
	search: string,
	signal?: AbortSignal,
): Promise<StoreAutoCompleteModel[]> {
	const response = await axios.post<unknown>(
		'api/stores/autocomplete',
		{
			searchText: search,
			existingStoreCodes: [],
		},
		{ signal: signal },
	);

	return storeAutoCompleteModelSchema.array().parse(response.data);
}
